
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[slug]",
      function () {
        return require("private-next-pages/groups/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/[slug]"])
      });
    }
  